'use client';

import { useCallback, useEffect } from 'react';
import { useExternalServiceStore } from 'src/stores/externalServiceStore';
import { shallow } from 'zustand/shallow';
import { RecaptchaAction, getRecaptchaToken as getRecaptchaTokenExecute } from './getRecaptchaToken';

export const useRecaptcha = () => {
  const { isLoadingRecaptcha, setShouldLoadRecaptcha } = useExternalServiceStore(
    ({ recaptchaReady, setShouldLoadRecaptcha }) => ({ isLoadingRecaptcha: !recaptchaReady, setShouldLoadRecaptcha }),
    shallow,
  );

  const getRecaptchaToken = useCallback(
    async (action: RecaptchaAction) => {
      if (isLoadingRecaptcha) {
        throw new Error('Please wait for recaptcha to load before invoking `getRecaptchaToken`');
      }

      const recaptchaToken = await getRecaptchaTokenExecute(action);
      return recaptchaToken;
    },
    [isLoadingRecaptcha],
  );

  // This is to ensure recaptcha is loaded on the client side.
  useEffect(() => {
    setShouldLoadRecaptcha();
  }, []);

  return {
    isLoadingRecaptcha,
    getRecaptchaToken,
  };
};
